import React, {Component, Fragment, useEffect, useRef, useState} from 'react'
import {getCurrencyData, getDeviseSymbol, LANGS} from "../../../i18n";
import {Button, ConfigProvider, Form, InputNumber, Select, Space} from "antd";
import {EuroCircleOutlined} from "@ant-design/icons";
import {getPurOrg} from "../../../utils";
import {startPaiement} from "../../../services/paiementLauncher";
import {useRouter} from "next/router";
import {ASSET_URL} from "../../../config";
import {getLayoutDirection} from "../../../locales";
import {getPrimaryColor} from "../tokens";
import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";

export default function BlockDon({context,campagneData,campagneTarget})
{

    let primaryColor=getPrimaryColor(campagneData.config)

    const productMonth=campagneData?.config?.productMonth || false
    // Durée imposée : seul un nombre l'active (cf. modal-don.js) — un réglage
    // vidé depuis l'admin arrive en `null` et doit rendre la main au donateur.
    const forceMonthNb=typeof campagneData?.config?.forceMonthNb==="number" ? campagneData.config.forceMonthNb : undefined
    // Affichage seulement : un don étalé est présenté par sa mensualité (total ÷ nb de mois).
    const monthlyAmountDisplay=!productMonth && !!campagneData?.config?.monthlyAmountDisplay

    const form=useRef(null)

    const router=useRouter()
    const [currencyData,setCurrencyData]=useState(LANGS[0].currencyData)

    useEffect(() => {
        const selectedCurrencyData=getCurrencyData(context.lang)
        setCurrencyData(selectedCurrencyData)

    }, []);


    const convertAmount=(amount)=>{
        return Math.round(amount/currencyData.rate)
    }

    const currencyAfterField=()=>{
        if(!Array.isArray(org?.languages) || org.languages.length===0){
            if(productMonth){
                return <Space><EuroCircleOutlined/> <Trans>/Mois</Trans></Space>
            }
            return <EuroCircleOutlined/>
        }

        const currencys=[LANGS[0]?.currencyData]

        for(let l of org.languages){
            const _currency=getCurrencyData({value:l})
            if(!_currency){
                continue
            }

            if(!currencys.find(i=>i.id===_currency.id)){
                currencys.push(_currency)
            }
        }

        //console.log(currencys)

        return (
            <Space>
                <Select value={currencyData.id} onChange={(v)=>setCurrencyData(currencys.find(i=>i.id===v))}>
                    {currencys.map(c=>(<Select.Option value={c.id}>{c.symbol}</Select.Option>))}
                </Select>

                {productMonth && t`/Mois`}
            </Space>
        )
    }

    const onSubmit=(data)=>
    {
        if(data.montant<1){
            return false
        }

        const campagne={
            ...campagneTarget,
            theme:campagneData?.config?.secondaryColor,
            label:campagneData.label || "",
        }

        if(data.team){
            campagne.team=data.team
        }

        var object={
            montant: data.montant,
            divide:data.divide,
            maxDivide:campagneData?.config?.maxDivideNB,
            returnUrl: window.location.href,
            organisation:getPurOrg(org),
            type: "CAMPAGNE",
            typeId: campagneData.id,
            cerfa: true,
            campagne:campagne,
            monthlyAmountDisplay:monthlyAmountDisplay
        }

        if(productMonth)
        {
            object.maxNbMonth=campagne?.config?.maxNbMonth
            object.nbMonth=data.nbMonth

            if(forceMonthNb!==undefined){
                object.nbMonth=forceMonthNb
                object.fixedNbMonth=true
            }
        }

        if(currencyData.id!=="EUR"){
            object.montant=Math.round(object.montant*currencyData.rate)
        }


        // Centralisé : source (APP/WEB) + returnUrl (deep link en app) + sessionStorage
        // + redirect. Cf. services/paiementLauncher.
        startPaiement(object, {org, router, query: "theme=CAMPAGNE"})
    }

    let initialValues={divide: 0,nbMonth:12, ...campagneTarget}

    if(forceMonthNb!==undefined){
        initialValues.nbMonth=forceMonthNb
        initialValues.montant=0
    }


    let montantRules=[{required: true, message: t`Minimum 1€`}]
    if(campagneData.config?.minMontant){
        montantRules=[{required:true,validator:(_,_value)=>_value>=campagneData.config.minMontant?Promise.resolve(true):Promise.reject(t`Minimum ${campagneData.config.minMontant}${getDeviseSymbol(context)}`)  }]
    }


    const {org}=context


    let presetButtons=campagneData?.products.map(i=>{
        return{
            text:convertAmount(i.montant)+" "+currencyData.symbol,
            montant:convertAmount(i.montant)
        }
    })

    if(Array.isArray(campagneData?.config["ald.presetButtons"]) && campagneData.config["ald.presetButtons"].length>0){
        presetButtons=campagneData.config["ald.presetButtons"]
    }

    return (
        <ConfigProvider
            direction={getLayoutDirection(context.langValue)}
            theme={{
                token: {
                    borderRadiusLG:5,
                    borderRadiusSM:5,
                    colorPrimary:primaryColor
                }
            }}
        >
        <div id={"block-don"} className={"block-don"} style={{borderRadius:5,padding:10,display:"flex",flexDirection:"column",alignItems:"center",gap:15}}>

            <img src={campagneData?.config["ald.logo"]?ASSET_URL+"/"+campagneData.config["ald.logo"]:org.logo} style={{borderRadius:"100%",height:100,width:100}}/>

            <span style={{fontWeight:"bold"}}>{campagneData?.config["ald.name"] || org.name}</span>

            <div style={{borderTop:"1px solid #FFF",width:"90%"}}/>

            <span style={{fontWeight: "bold"}}><Trans>Montant de votre don</Trans></span>

            <div style={{display:"flex",flexDirection:"row",alignItems:"center",justifyContent:"center",flexWrap:"wrap",gap:10}}>
                {presetButtons.map(i=>{
                    const label = i.text || (convertAmount(i.montant) + " " + currencyData.symbol)
                    return(
                        <div className={"block-don-product-item"} style={{borderRadius:5,fontSize:16,padding:"0 5px",fontWeight:"600",cursor:"pointer"}} onClick={()=>onSubmit({montant:i.montant})}>
                            {label}
                        </div>
                    )
                })}
            </div>


            <Form
                ref={(ref) => form.current = ref}
                initialValues={{}}
                layout={"vertical"}
                onFinish={(data) => {
                    onSubmit(data)
                }}
                style={{width:"80%"}}
            >
                <Form.Item noStyle shouldUpdate>
                    {(e)=> {

                        let maxDivide=campagneData?.config?.maxDivideNB || 12
                        let maxNbMonth=campagneData?.config?.maxNbMonth || 12

                        const montant = e.getFieldValue("montant")
                        const divide = e.getFieldValue("divide")
                        const nbMonth = e.getFieldValue("nbMonth")

                        if(divide && montant<maxDivide) {
                            e.setFieldValue("divide",0)
                        }

                        return (
                            <Fragment>

                                <Form.Item
                                    name={"montant"}
                                    rules={montantRules}
                                >
                                    <InputNumber id={"montant"} placeholder={t`Autre Montant`} size="large" min={forceMonthNb!==undefined?0:1} style={{width: "100%",backgroundColor:"#FFF",borderRadius:10}} addonAfter={currencyAfterField()} readOnly={forceMonthNb!==undefined}/>
                                </Form.Item>


                                {!productMonth && maxDivide!==1 &&(
                                    <Form.Item name={"divide"} style={{width: "100%"}}>
                                        <select
                                            disabled={montant < maxDivide}
                                            className={"form-control"}
                                            style={{width: "100%"}}>
                                            <option value={0}>{monthlyAmountDisplay ? t`Donner en une seule fois` : t`Ne pas diviser mon don`}</option>
                                            {Array.from(Array(maxDivide-1).keys()).map((i) => {
                                                const nb=i + 2
                                                // Arrondi au supérieur : c'est la mensualité réellement prélevée (cf. tunnel de paiement).
                                                const perMonth=Math.ceil(montant / nb)
                                                if(monthlyAmountDisplay){
                                                    return <option key={i} value={nb}><Trans>{perMonth}{currencyData.symbol} /mois pendant {nb} mois</Trans></option>
                                                }
                                                return <option key={i} value={nb}><Trans>Diviser mon don sur {i + 2} mois soit ({Math.ceil(montant / nb)}{currencyData.symbol} /mois)</Trans></option>
                                            })}
                                        </select>
                                    </Form.Item>
                                )}

                                {productMonth &&(
                                    <Form.Item name={"nbMonth"} style={{width: "100%"}}>
                                        <select className={"form-control"} style={{width: "100%"}} disabled={forceMonthNb!==undefined}>
                                            <option value={0}><Trans>Sans limite de temps et peut être arrêté à tout moment</Trans></option>
                                            {Array.from(Array(maxNbMonth-1).keys()).map((i) => {
                                                return <option key={i} value={i + 2}><Trans>Pendant {i + 2} mois</Trans></option>
                                            })}
                                        </select>
                                    </Form.Item>
                                )}


                                {Array.isArray(campagneData?.teams) && campagneData.teams.length>0 && campagneData?.config?.modalHideTeam!==true && (
                                    <Form.Item
                                        name={"team"}
                                    >
                                        <select
                                            className={"form-control"}
                                            placeholder={t`Equipe`}
                                        >
                                            <option value={""}><Trans>Sans Equipe</Trans></option>
                                            {campagneData?.teams.filter(i=>!i.hidden).map(i => (
                                                <option key={i.param} value={i.param}>{i.label}</option>))}
                                        </select>
                                    </Form.Item>
                                )}

                            </Fragment>
                        )
                    }}
                </Form.Item>


                <Form.Item>
                    <div className={"block-don-donation-button"} onClick={()=>form.current.submit()}>{campagneData?.config?.donationButtonText || t`Faire un don`}</div>
                </Form.Item>
            </Form>


        </div>
        </ConfigProvider>
    )
}
